import R from 'ramda';

export const ofTypes = R.curry((types, type) =>
  R.pipe(R.prop('type'), R.contains(R.__, types))(type),
);



// WEBPACK FOOTER //
// ./src/common/epicHelpers.js